import React from 'react';
import WaHtmlEditor from '../wa-html-editor';
import { default as EditorContext } from '../../editor-context-provider/context';

export default props => (
  <EditorContext.Consumer>
    {({ editor: editorRoot, blankPageURL, macros }) => (
      <WaHtmlEditor
        editorRoot={editorRoot}
        blankPageURL={blankPageURL}
        macros={macros}
        {...props}
      />
    )}
  </EditorContext.Consumer>
);